import { calculatePercentage } from '@common/util/math';

export const getAllRowsFromCourseRow = (courseRow) => {
  const allRows = [];

  courseRow.data.forEach((evaluationAgeRow) => {
    evaluationAgeRow.data.forEach((cognitiveProcessAgeRow) => {
      cognitiveProcessAgeRow.data.forEach((statsRow) => {
        allRows.push(statsRow);
      });
    });
  });

  return allRows;
};

export const courseHasCognitiveSubprocesses = (courseRow) => {
  if (courseRow.course === 'all') {
    return false;
  }

  const allRows = getAllRowsFromCourseRow(courseRow);

  return allRows.some(
    (row) =>
      row.cognitiveSubprocess !== null && row.cognitiveSubprocess !== 'all',
  );
};

export const courseHasDifferentAges = (courseRow) => {
  return courseRow.data.some(
    (evaluationAgeRow) => evaluationAgeRow.data.length > 1,
  );
};

export const getEvaluationAgeTotalRows = (evaluationAgeRow) => {
  return evaluationAgeRow.data.reduce((total, cognitiveProcessAgeRow) => {
    return total + cognitiveProcessAgeRow.data.length;
  }, 0);
};

export const groupByCognitiveProcess = (statRows) => {
  const cognitiveProcessGroups = {};
  statRows.forEach((statRow) => {
    if (!cognitiveProcessGroups[statRow.cognitiveProcess]) {
      cognitiveProcessGroups[statRow.cognitiveProcess] = [];
    }
    cognitiveProcessGroups[statRow.cognitiveProcess].push(statRow);
  });
  return cognitiveProcessGroups;
};

export const getFormattedAge = (age) => `${age} - ${age + 1}`;

export const getFormattedFraction = (part, total) => `${part} / ${total} (
          ${calculatePercentage(part, total)}
          %)`;
